import {mapActions, mapState} from "vuex"

export default {
  computed: mapState("modal", [
    "currentModal",
  ]),

  methods: {
    ...mapActions("modal", [
      "showModal",
      "hideModal",
    ]),
  },
}
